import { createThunk } from 'utils/createThunk';
import * as backendAPI from 'api/backendAPI/models';
import types from 'constants/actionTypes';

export const fetchModelTemplatesSpecs = createThunk({
  apiCall: backendAPI.getModelTemplatesSpecs,
  type: types.GET_MODEL_TEMPLATES_SPECS_REQUEST,
});

export const fetchModelTemplatesWorkingState = createThunk({
  apiCall: backendAPI.getModelTemplatesWorkingState,
  type: types.GET_MODEL_TEMPLATES_WORKING_STATE_REQUEST,
});

export const fetchModelsViewers = createThunk({
  apiCall: backendAPI.getModelsViewers,
  type: types.GET_MODELS_VIEWERS_REQUEST,
});

export const updatePriorityQuantity = (templateId, priority, quantity) => {
  return {
    type: types.UPDATE_PRIORITY_QUANTITY,
    payload: { templateId, priority, quantity },
  };
};

export const updateInReviewTemplatePriority = (templateId, priority) => {
  return {
    type: types.UPDATE_IN_REVIEW_TEMPLATE_PRIORITY,
    payload: { templateId, priority },
  };
};

export const swapTemplates = (oldTemplateId, newTemplateId) => {
  return {
    type: types.SWAP_TEMPLATES,
    payload: { oldTemplateId, newTemplateId },
  };
};

export const updateModelWorkingState = createThunk({
  apiCall: backendAPI.updateModelWorkingState,
  type: types.ADD_TEMPLATES_TO_CART_REQUEST,
});

export const removeTemplateFromWorkingState = (modelId, templateId) => {
  return {
    type: types.REMOVE_TEMPLATE_FROM_WORKING_STATE,
    payload: { modelId, templateId },
  };
};

export const addTemplateToWorkingState = (
  modelId,
  templateId,
  duplicateTemplateId = null,
) => {
  return {
    type: types.ADD_TEMPLATE_TO_WORKING_STATE,
    payload: { modelId, templateId, duplicateTemplateId },
  };
};

export const setModelIsActive = () => {
  console.log('activity-registered');
  return {
    type: types.SET_MODEL_IS_ACTIVE,
  };
};

export const setModelIsNotActive = () => ({
  type: types.SET_MODEL_IS_NOT_ACTIVE,
});

export const setModelLockExpired = () => ({
  type: types.SET_MODEL_LOCK_EXPIRED,
});

export const resetModelLockExpired = () => ({
  type: types.RESET_MODEL_LOCK_EXPIRED,
});
